import { FormControlHelper, FormControlHelperText } from "@gluestack-ui/themed";
import { IInputHelperText } from "./types";

export const InputHelperText = ({ text, hasError }: IInputHelperText) => {
  if (!text || hasError) return null;

  return (
    <FormControlHelper>
      <FormControlHelperText>{text}</FormControlHelperText>
    </FormControlHelper>
  );
};
